import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Seminar = () => {
  // Array of image filenames in the public/assets folder
  const imageFilenames = [
    "1.jpg", "39.jpg", "38.jpg", "2.jpg", "3 (1).jpg", "4 (1).jpg", "5 (1).jpg", "6 (1).jpg",
    "16.jpg", "17.jpg", "18.jpg", "19.jpg", "20.jpg", "21.jpg", "25.jpg", "28.jpg",
    "30.jpg", "31.jpg", "32.jpg", "33.jpg", "34.jpg", "35.jpg", "36.jpg",
    "7 (1).jpg", "8 (1).jpg", "9 (1).jpg", "10 (1).jpg", "11 (1).jpg", "12 (1).jpg",
    "13.jpg", "14 (1).jpg", "15 (1).jpg"
  ];

  // Build full paths to images in the public folder
  const images = imageFilenames.map((filename) => `/assets/${filename}`);

  return (
    <div className="bg-white">
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div className="py-12 px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
          SEMINARS
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((src, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-lg shadow-lg group"
            >
              <img
                src={src}
                alt={`Seminar ${index + 1}`}
                className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Seminar;
